import React, { lazy } from 'react';
import {
    Routes,
    Route,
    Link as RouterLink,
    useLocation,
} from 'react-router-dom';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import withRoot from '../../wiring/with-root';
import themer from '../../styles/material-theme';
import StyledLink from '../../components/styled-breadcrumb';
import NotRegisteredBlock from '../../components/not-registered-block';

import SideNav from './components/side-nav';

const Error404 = lazy(() => import('../../routes/error/404'));
const SupportStep = lazy(() => import('../../routes/support/steps'));

const SideNavLayout = () => {
    const location = useLocation();
    return (
        <>
            <Container>
                <Stack direction={{ xs: 'column', lg: 'row' }} pt={6} pb={8}>
                    <Box>
                        <StyledLink to="/support/overview" component={RouterLink}>Back to Process Overview</StyledLink>
                        <SideNav />
                    </Box>
                    <Box pt={{ xs: 4, lg: 10 }} sx={{ flex: 1, minWidth: 0 }}>
                        <Routes>
                            {/* Support */}
                            <Route path="1" element={<SupportStep page="review" />} />
                            <Route path="2" element={<SupportStep page="file" />} />
                            <Route path="3" element={<SupportStep page="give" />} />
                            <Route path="4" element={<SupportStep page="prepare" />} />
                            <Route path="5" element={<SupportStep page="day" />} />
                            <Route path="6" element={<SupportStep page="after" />} />

                            <Route path="1/workshops" element={<SupportStep page="review" workshops />} />
                            <Route path="2/workshops" element={<SupportStep page="file" workshops />} />
                            <Route path="3/workshops" element={<SupportStep page="give" workshops />} />
                            <Route path="4/workshops" element={<SupportStep page="prepare" workshops />} />
                            <Route path="5/workshops" element={<SupportStep page="day" workshops />} />
                            <Route path="6/workshops" element={<SupportStep page="after" workshops />} />

                            <Route path="/*" element={<Error404 />} />
                        </Routes>
                    </Box>
                </Stack>
            </Container>
            {!/^\/support\/6(?:\/|$)/.test(location.pathname) && (
                <NotRegisteredBlock />
            )}
        </>
    );
};

export default withRoot(SideNavLayout, themer);
